import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
// import Role from "../config/Roles";

/** public/private routes */
import InnerContent from "./InnerContent";
import PrivateRoute from "./PrivateRoutes";
import ProtectedRoutes from "./ProtectedRoutes";
import PublicRoutes from "./PublicRoutes";

/** error page routes */
import Error403 from "../pages/ErrorPages/Error403";
import Error404 from "../pages/ErrorPages/Error404";
import Error500 from "../pages/ErrorPages/Error500";

/** authentication routes */
import Login from "../pages/Auth/Login";
import Register from "../pages/Auth/Register";

/** dashboard page route */
import Dashboard from "../pages/Dashboard/Dashboard";

/** store config page route */
import Storeconfig from "../pages/MainPages/StoreConfig/StoreConfig";

// /** Delivveries page route */
// import Deliveries from "../pages/MainPages/Deliveries/DeliveriesList";
// import DeletedDeliveries from "../pages/MainPages/Deliveries/DeletedDeliveries";
// import ManageDeliveries from "../pages/MainPages/Deliveries/ManageDeliveries";
// import ManageStatus from "../pages/MainPages/Deliveries/ManageStatus";
// import ManageCategory from "../pages/MainPages/Deliveries/ManageCategory";

/**Inventory Routes*/
/** ==> Items  */
import Items from "../pages/MainPages/Inventory/Items/Items";
import ManageItems from "../pages/MainPages/Inventory/Items/ManageItems";
import DeletedItems from "../pages/MainPages/Inventory/Items/DeletedItems";
import ItemsCustomeField from "../pages/MainPages/Inventory/Items/Itemcustomfield";
import CountInventory from "../pages/MainPages/Inventory/Items/CountInventory";
import ShowClosedCounts from "../pages/MainPages/Inventory/Items/ShowClosedCounts";
import NewInventoryCount from "../pages/MainPages/Inventory/Items/NewInventoryCount";
import ExcelImport from "../pages/MainPages/Inventory/Items/ExcelImport";
import CountInventoryBarcodeLabel from "../pages/MainPages/Inventory/Items/CountInventoryBarcodeLabel";

/** ==> Item Kits  */
import Itemskit from "../pages/MainPages/Inventory/Itemskit/itemskit";
import Manageitemskit from "../pages/MainPages/Inventory/Itemskit/Manageitemskit";
import DeletedItemsKit from "../pages/MainPages/Inventory/Itemskit/DeletedItemsKit";
import ItemKitCustomField from "../pages/MainPages/Inventory/Itemskit/ItemsKitCustomField";

/** ==> Tags  */
import Tags from "../pages/MainPages/Inventory/Tags/Tags";

/** ==> Manufacturers  */
import Manufacturers from "../pages/MainPages/Inventory/Manufacturers/Manufacturers";

/** ==> Modifiers  */
import Modifiers from "../pages/MainPages/Inventory/Modifiers/Modifiers";
import ModifiersManage from "../pages/MainPages/Inventory/Modifiers/ModifiersManage";

/** ==> Categories  */
import Categories from "../pages/MainPages/Inventory/Categories/Categories";

/** ==> Attributes  */
import Attributes from "../pages/MainPages/Inventory/Attributes/Attributes";

/** ==> PriceRule  */
import PriceRule from "../pages/MainPages/PromoRule/PriceRule/PriceRule";
import ManagePriceRule from "../pages/MainPages/PromoRule/PriceRule/ManagePriceRule";
import DeletedPriceRules from "../pages/MainPages/PromoRule/PriceRule/DeletedPriceRules";

/** ==> Brand   */
import Brand from "../pages/MainPages/Inventory/Brand/Brand";

/**End Inventory*/

/**Customers Routes*/
import Customers from "../pages/MainPages/Contacts/Costomers/Customers";
import ManageCustomer from "../pages/MainPages/Contacts/Costomers/ManageCustomer";
import DeletedCustomers from "../pages/MainPages/Contacts/Costomers/DeletedCustomers";
import CustomerIntakeForm from "../pages/MainPages/Contacts/Costomers/CustomerIntakeForm";
import ImportExcelCustomers from "../pages/MainPages/Contacts/Costomers/ImportExcelCustomers";
import CustomerBarcodeLabel from "../pages/MainPages/Contacts/Costomers/CustomerBarcodeLabel";
import CustomFieldConfigurationCustomer from "../pages/MainPages/Contacts/Costomers/CustomFieldConfigurationCustomer";
/**End Customers */

/**Supplier Routes*/
import Suppliers from "../pages/MainPages/Suppliers/Suppliers";
import ManageSuppliers from "../pages/MainPages/Suppliers/ManageSuppliers";
import CustomFIeldConfigSuppliers from "../pages/MainPages/Suppliers/CustomFIeldConfigSuppliers";
import DeletedSuppliers from "../pages/MainPages/Suppliers/DeletedSuppliers";
import ImportExcelSupplier from "../pages/MainPages/Suppliers/ImportExcelSupplier";
import Employees from "../pages/MainPages/Employees/Employees";
import ManageEmployee from "../pages/MainPages/Employees/ManageEmployee";
import Permission from "../pages/MainPages/Employees/Permission";
import NewPermissionTemplate from "../pages/MainPages/Employees/NewPermissionTemplate";
/**End Supplier */

/**Receiving */
import Receiving from "../pages/MainPages/Receiving/Receiving";
import ManageReceiving from "../pages/MainPages/Receiving/ManageReceiving";

import CustomFIeldConfigReceiving from "../pages/MainPages/Receiving/CustomFieldConfigReceiving";
import SuspendedReceiving from "../pages/MainPages/Receiving/SuspendedReceiving";
import ReceivingReceipt from "../pages/MainPages/Receiving/ReceivingReceipt";
import BatchReceiving from "../pages/MainPages/Receiving/BatchReceiving";
import CreatePurchaseOrders from "../pages/MainPages/Receiving/CreatePurchaseOrder";
import RecievingBarcodeLabel from "../pages/MainPages/Receiving/RecievingBarcodeLabel";
import TransferReceiving from "../pages/MainPages/Receiving/TransferRequest";
import IncomingTransfer from "../pages/MainPages/Receiving/IncomingTransfer";
import PayBills from "../pages/MainPages/Receiving/PayBills";

/** End Receiving */

/** Sales **/
import Sales from "../pages/MainPages/Sales/Sales";
import EcomOrders from "../pages/MainPages/Sales/EcomOrders";
import ManageSale from "../pages/MainPages/Sales/ManageSale";
import CustomFIeldConfigSales from "../pages/MainPages/Sales/CustomeFieldConfigSales";
import SuspendedSales from "../pages/MainPages/Sales/SuspendedSales";
import SalesWorkOrders from "../pages/MainPages/Sales/SalesWorkOrders";
import CustomerFacingDisplay from "../pages/MainPages/Sales/CustomerFacingDisplay";
import BatchSale from "../pages/MainPages/Sales/BatchSale";
import SearchSale from "../pages/MainPages/Sales/SearchSale";
import ShowLastSaleReceipt from "../pages/MainPages/Sales/ShowLastSaleReceipt";
import SaleBarcodeLabel from "../pages/MainPages/Sales/SaleBarcodeLabel";
import ShowAllReceiptToday from "../pages/MainPages/Sales/ShowAllReceiptToday";

/**End Sales */

/** GiftCard **/
import GiftCard from "../pages/MainPages/GiftCard/GiftCard";
import ManageGiftCard from "../pages/MainPages/GiftCard/ManagaGiftCard";
import DeletedGiftCard from "../pages/MainPages/GiftCard/DeletedGiftCards";
/** End GiftCard **/

/**Work Orders Routes*/
// import WorkOrders from "../pages/MainPages/WorkOrders/WorkOrders";
// import EditWorkOrder from "../pages/MainPages/WorkOrders/EditWorkOrder";
// import ManageWorkorderStatues from "../pages/MainPages/WorkOrders/ManageStatus";
// import ManageWorkorderDeleted from "../pages/MainPages/WorkOrders/ManageDelete";
// import Appointment from "../pages/MainPages/Appointment/Appointment";
// import AppointmentIntakeForm from "../pages/MainPages/Appointment/NewAppointment";
// import DeletedAppointment from "../pages/MainPages/Appointment/DeletedAppointment";
// import ManageCategories from "../pages/MainPages/Appointment/AppointmentCategories";
import CustomFieldConfigEmployee from "../pages/MainPages/Employees/CustomFieldConfigEmployee";
import DeletedEmployees from "../pages/MainPages/Employees/DeletedEmployee";
import ForgotPassword from "../pages/Auth/ForgotPassword";
// import WorkOrderBarcodeLabel from "../pages/MainPages/WorkOrders/WorkOrderBarcodeLabel";
import ResetPassword from "../pages/Auth/ResetPassword";
/**Work Orders Routes*/

/** EmailTemplates Routes */
import EmailTemplates from "../pages/MainPages/EmailTemplates/EmailTemplates";

// locations
import Locations from "../pages/MainPages/Locations/Location";
import ManageLocations from "../pages/MainPages/Locations/ManageLocations";
import DeletedLocations from "../pages/MainPages/Locations/DeletedLocations";
import EditProfile from "../pages/Dashboard/Sidebar/editprofile";
import ManageEmailTemplates from "../pages/MainPages/EmailTemplates/ManageEmailTemplates";
// import ManageEmailTemplate from "../pages/MainPages/Deliveries/ManageEmailTemplate";
// import ManageTemplates from "../pages/MainPages/WorkOrders/ManageTemplate";
import ItemNotCountedAndInStock from "../pages/MainPages/Inventory/Items/ItemNotCountedAndInStock";

// Ecomm Config
import EcommConfig from "../pages/MainPages/EcommConfig/EcommConfig";
import ItemNotCounted from "../pages/MainPages/Inventory/Items/ItemNotCounted";

//Loaction Rack System
import LoactionRackMangement from "../pages/MainPages/LoactionRackManage/LoactionRackManagement";

//Reports
import ReportsList from "../pages/MainPages/Reports/ReportList";
import CustomerBalanceSummary from "../pages/MainPages/Reports/CustomerBalanceSummary";
import ExpenseReport from "../pages/MainPages/Reports/ExpenseReport";
import CustomerContactList from "../pages/MainPages/Reports/CustomerContactList";
import SalesbyCustomerDetail from "../pages/MainPages/Reports/SalesbyCustomerDetail";
import SalesbyCustomerTypeDetail from "../pages/MainPages/Reports/SalesbyCustomerTypeDetail";
import TransactionListByCustomer from "../pages/MainPages/Reports/TransactionListByCustomer";
import SalesbyCustomerSummaryReport from "../pages/MainPages/Reports/SalesbyCustomerSummaryReport";
import VendorBalanceSummary from "../pages/MainPages/Reports/VendorBalanceSummary";
import ExpensesbyVendorSummary from "../pages/MainPages/Reports/ExpensesbyVendorSummary";
import OpenPurchaseOrderList from "../pages/MainPages/Reports/OpenPurchaseOrderList";
import TransactionListbyVendor from "../pages/MainPages/Reports/TransactionListbyVendor";
import TransactionListbyDate from "../pages/MainPages/Reports/TransactionListbyDate";
import InvoicesandReceivedPayments from "../pages/MainPages/Reports/InvoicesandReceivedPayments";
import OpenInvoices from "../pages/MainPages/Reports/OpenInvoices";
import SalesbyProductServiceDetail from "../pages/MainPages/Reports/SalesbyProductServiceDetail";
import VendorBalanceDetail from "../pages/MainPages/Reports/VendorBalanceDetail";
import OpenPurchaseOrderDetail from "../pages/MainPages/Reports/OpenPurchaseOrderDetail";
import VendorContactList from "../pages/MainPages/Reports/VendorContactList";
import EmployeeContactList from "../pages/MainPages/Reports/EmployeeContactList";
import ProfitandLossbyCustomer from "../pages/MainPages/Reports/ProfitandLossbyCustomer";
import TrialBalance from "../pages/MainPages/Reports/TrialBalance";
import ProfitandLossDetail from "../pages/MainPages/Reports/ProfitandLossDetail";
import BalanceSheetDetail from "../pages/MainPages/Reports/BalanceSheetDetail";
import IncomebyCustomerSummary from "../pages/MainPages/Reports/IncomebyCustomerSummary";
import SalesbyProductServiceSummary from "../pages/MainPages/Reports/SalesbyProductServiceSummary";
import ProductServiceList from "../pages/MainPages/Reports/ProductServiceList";
import BillsandAppliedPayments from "../pages/MainPages/Reports/BillsandAppliedPayments";
import UnpaidBills from "../pages/MainPages/Reports/UnpaidBills";
import BalanceSheetSummary from "../pages/MainPages/Reports/BalanceSheetSummary";
import AccountsPayableAgingDetail from "../pages/MainPages/Reports/AccountsPayableAgingDetail";
import BillPaymentList from "../pages/MainPages/Reports/BillPaymentList";
import AccountsReceivableAgingDetail from "../pages/MainPages/Reports/AccountsReceivableAgingDetail";
import AccountsReceivableAgingsummary from "../pages/MainPages/Reports/AccountsReceivableAgingSummary";
import AccountsPayableAgingsummary from "../pages/MainPages/Reports/AccountsPayableAgingsummary";
import SaleByEmployeeSummary from "../pages/MainPages/Reports/SaleByEmployeeSummary";
import InventoryDetailedReport from "../pages/MainPages/Reports/InventoryDetailedReport";
import InventorySummaryReport from "../pages/MainPages/Reports/InventorySummaryReport";
import ItemSummaryReport from "../pages/MainPages/Reports/ItemsSummaryReport";
import CustomSerachReport from "../pages/MainPages/Reports/CustomSerachReport";
import ReceivingCustomReport from "../pages/MainPages/Reports/ReceivingCustomReport";
import supplierSummaryReport from "../pages/MainPages/Reports/SupplierSummaryReport";
// Account types
import ChartOfAccount from "../pages/MainPages/Accounting/ChartOfAccount";
import ChartOfAccountManage from "../pages/MainPages/Accounting/ChartOfAccountMange";
// import AccountTypesManage from "../pages/MainPages/Accounting/AccountTypeMange"
import CharOfAccountTypes from "../pages/MainPages/Accounting/ChartOfAccountType";
// import AccountTypesDetailsManage from "../pages/MainPages/Accounting/AccountTypeDetailsManage"
import AccountTypes from "../pages/MainPages/Accounting/AccountType";
import AccountTypesDetails from "../pages/MainPages/Accounting/AccountTypeDetails";
import Transfer from "../pages/MainPages/Accounting/Transfer/Transfer";
import ManageTransfer from "../pages/MainPages/Accounting/Transfer/ManageTransfer";
import JournalEntry from "../pages/MainPages/Accounting/Journal/JournalEntry";
import BankDeposits from "../pages/MainPages/Accounting/Bank Deposit/BankDeposit";
// import BankDeposits from "../pages/MainPages/Accounting/Bank Deposit";
import ReceivePayment from "../pages/MainPages/Sales/ReceivePayment";
import { ToastContainer } from "react-toastify";
import { RoleTier } from "../pages/MainPages/PromoRule/RoleTier/RoleTier";
import { RecallPrice } from "../pages/MainPages/PromoRule/RecallPrice/RecallPrice";
import { InventoryAdjustment } from "../pages/MainPages/Accounting/InventoryAdjustment";
// import { ManageAdjustment } from "../pages/MainPages/Accounting/ManageAdjustment";
import { ManageFormAdjustment } from "../pages/MainPages/Accounting/ManageFormAdjustment";

//Task
import Task from "../pages/MainPages/Accounting/Task/Task";
import ManageTask from "../pages/MainPages/Accounting/Task/ManageTask";
import ViewRegister from "../pages/MainPages/Accounting/ViewRegister";
import ImportItems from "../pages/MainPages/Inventory/Items/ImportItems";
import { ManageInactiveAccount } from "../pages/MainPages/Accounting/ManageInactiveAccount";
import { ChartOfAccountReport } from "../pages/MainPages/Accounting/ChartOfAccountReport";
import { Journal } from "../pages/MainPages/Accounting/Journal/Journal";
import PaymentLog from "../pages/MainPages/Accounting/PaymentLog";
import CustomerBalanceDetail from "../pages/MainPages/Reports/CustomerBalanceDetail";
import EcommUsers from "../pages/MainPages/Users/EcommUsers";
import ItemProfitAbilityByCustomer from "../pages/MainPages/Reports/ItemProfitAbilityByCustomer";
import ItemBarcodeLabel from "../pages/MainPages/Contacts/Costomers/ItemBarcodeLabel";
import QuickbookSync from "../pages/MainPages/Quickbooks/QuickbookSync";
import { Pages } from "@mui/icons-material";
import SalesDeliveryReport from "../pages/MainPages/Reports/SalesDeliveryReport";
import SalesByCategories from "../pages/MainPages/Reports/SalesByCategories";
import DeletedSales from "../pages/MainPages/Reports/DeletedSales";
import SaleByEmployee from "../pages/MainPages/Reports/SaleByEmployee";
import RepotsManufacturer from "../pages/MainPages/Reports/RepotsManufacturer";
import Pricerulesummary from "../pages/MainPages/Reports/PriceRule";
import ReceivingReport from "../pages/MainPages/Reports/ReceivingList";
import PaymentDetailReport from "../pages/MainPages/Reports/PaymentDetailReport";
import PayBillReport from "../pages/MainPages/Reports/PayBillReport";
import PaymentSummaryReport from "../pages/MainPages/Reports/PaymentSummaryReport";
// import PayBillReport from "../pages/MainPages/Reports/PayBillReport";
import CustomerSummaryReport from "../pages/MainPages/Reports/CustomerSummaryReport";
import SaleByCustomerDetailReport from "../pages/MainPages/Reports/SaleByCustomerDetailReport";
import SupplierSummaryReport from "../pages/MainPages/Reports/SupplierSummaryReport";
import ReceivePaymentQuickbook from "../pages/MainPages/Sales/ReceivePaymentQuickbook";
import PayBillsQuickbook from "../pages/MainPages/Receiving/PayBillsQuickbook";
import PayBillsExpensesQuickbook from "../pages/MainPages/Receiving/PayBillsExpensesQuickbook";
import ViewRegisterQuickbook from "../pages/MainPages/Accounting/ViewRegisterQuickbook";
import ExpenseList from "../pages/MainPages/Accounting/ExpenseList";
import InActiveEmployees from "../pages/MainPages/Employees/InActiveEmployees";
import InventoryPrint from "../pages/MainPages/Inventory/Items/InventoryPrint";
import DriverDailySheet from "../pages/MainPages/Inventory/Items/DriverDailySheet";
import DriverTaskList from "../pages/MainPages/Sales/DriverTaskList";
import DriverTaskReceipt from "../pages/MainPages/Sales/DriverTaskReceipt";
import RecevingPaymentSync from "../pages/MainPages/Sales/RecevingPaymentSync";
import PosPage from "../components/Pos/PosPage";
import PromotionPrice from "../pages/MainPages/PromoRule/PromotionPrice";
import Scanner from "../components/ScannerHtml5/Scanner";
import ScannerTest from "../components/Pos/ScannerTest";
// import GeorapBox from "../components/Pos/GeorapBox/GeorapBox";
import ScanToCart from "../components/ScanToCart/ScanToCart";
import ExpenseQuickbooks from "../pages/MainPages/Receiving/ExpenseQuickbook";
import RecevingPosPage from "../components/Pos/RecevingPosPage";

import ExpenseNewLayout from "../pages/MainPages/Receiving/ExpenseNewLayout";
import PosRegisterPage from "../components/Pos/PosRegisterPage";
import PosRegisterDetailPage from "../components/Pos/PosRegisterDetailPage";
import RegisterAddRemoveAmount from "../components/Pos/RegisterAddRemoveAmount";
import DetailedRegisterLogsReport from "../pages/MainPages/Reports/DetailedRegisterLogsReport";
import RegisterSummaryReport from "../pages/MainPages/Reports/RegisterSummaryReport";
import PaymentMethods from "../pages/MainPages/Accounting/PaymentMethods";
import MasterRegister from "../pages/MainPages/Employees/MasterRegister";
import RegistersReportByPayementMethods from "../pages/MainPages/Reports/RegistersReportByPayementMethods";
import InventoryStockStatus from "../pages/MainPages/PublicInventoryStockStatus/InventoryStockStatus";
import InventoryStockStatusByCategory from "../pages/MainPages/PublicInventoryStockStatus/InventoryStockStatusByCategory";
import RecvPosPage from "../components/Pos/RecvPosPage";
import { AccountsRunReport } from "../pages/MainPages/Accounting/AccountsRunReport";
import ItemQantity from "../pages/MainPages/Reports/ItemQantity";
import ItemDetilReportQty from "../pages/MainPages/Reports/ItemDetilReportQty";
import TemporaryActivatedItems from "../pages/MainPages/Inventory/Items/TemporaryActivatedItems";
import SalesByBrandsReport from "../pages/MainPages/Reports/SalesByBrandsReport";
import PurchaseByBrands from "../pages/MainPages/Reports/PurchaseByBrands";
import PurchaseByCategories from "../pages/MainPages/Reports/PurchaseByCategories";
import SalesByCategoriesNew from "../pages/MainPages/Reports/SalesByCategoriesNew";
import SalesByBrandAgingReport from "../pages/MainPages/Reports/SalesByBrandAgingReport";
import SalesByCategoriesAgingReport from "../pages/MainPages/Reports/SalesByCategoriesAgingReport";
import SalesVelocityReport from "../pages/MainPages/Reports/SalesVelocityReport";
import Demoreport from "../pages/MainPages/Reports/Demoreport";
import ManageLocationsNew from "../pages/MainPages/Locations/ManageLocationsNew";
import SubCompany from "../pages/MainPages/LoactionRackManage/SubCompany";
import ManageSubCompany from "../pages/MainPages/LoactionRackManage/ManageSubCompany";
import ViewRegisterQuickbookSc from "../pages/MainPages/Accounting/ViewRegisterQuickbookSs";
import ProfitByDeliveryMethodsSummary from "../pages/MainPages/Reports/ProfitByDeliveryMethodsSummary";
import ProfitByDeliveryMethodsDetail from "../pages/MainPages/Reports/ProfitByDeliveryMethodsDetail";
import PrintSaleReceipts from "../pages/MainPages/Sales/PrintSaleReceipts";
import Undepositedbalancesummery from "../pages/MainPages/Reports/Undepositedbalancesummery";
import InventoryValuationReport from "../pages/MainPages/Reports/InventoryValuationReport";
import DepositDetailReport from "../pages/MainPages/Reports/DepositDetailReport";
import SalesByCategoriesNewSummary from "../pages/MainPages/Reports/SalesByCategoriesNewSummary";
import SalesByBrandsNewSummary from "../pages/MainPages/Reports/SalesByBrandsNewSummary";
import PurchasesByBrandsNewSummary from "../pages/MainPages/Reports/PurchasesByBrandsNewSummary";
import PurchasesByCategoriesSummary from "../pages/MainPages/Reports/PurchasesByCategoriesSummary";

// Ecomm Config

// Reports

// Start
const MainRoute = (props) => {
  return (
    <>
      <Routes>
        <Route path="/" element={<ProtectedRoutes />}>
          <Route path="/" element={<InnerContent />}>
            {/* Dashboard */}
            <Route path="/" element={<Navigate replace to="dashboard" />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute permission="/dashboard">
                  <Dashboard />
                </PrivateRoute>
              }
            />

            {/* Items */}
            <Route
              path="/items"
              element={
                <PrivateRoute permission="/items">
                  <Items />
                </PrivateRoute>
              }
            />
            <Route
              path="/deleted-items"
              element={
                <PrivateRoute permission="/deleted-items">
                  <DeletedItems />
                </PrivateRoute>
              }
            />

            <Route
              path="/temporary-activated-items"
              element={
                <PrivateRoute permission="/temporary-activated-items">
                  <TemporaryActivatedItems />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-items"
              element={
                <PrivateRoute permission="/manage-items">
                  <ManageItems />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-items/:id"
              element={
                <PrivateRoute permission="/manage-items/:id">
                  <ManageItems />
                </PrivateRoute>
              }
            />
            <Route
              path="/items-custom-fields"
              element={
                <PrivateRoute permission="/items-custom-fields">
                  <ItemsCustomeField />
                </PrivateRoute>
              }
            />
            <Route
              path="/item-count-invetory"
              element={
                <PrivateRoute permission="/item-count-invetory">
                  <CountInventory />
                </PrivateRoute>
              }
            />
            <Route
              path="/invetory-print"
              element={
                <PrivateRoute permission="/invetory-print">
                  <InventoryPrint />
                </PrivateRoute>
              }
            />

            <Route
              path="/Driver-Daily-sheet"
              element={
                <PrivateRoute permission="/Driver-Daily-sheet">
                  <DriverDailySheet />
                </PrivateRoute>
              }
            />

            <Route
              path="/Driver-Task-List"
              element={
                <PrivateRoute permission="/Driver-Task-List">
                  <DriverTaskList />
                </PrivateRoute>
              }
            />

            <Route
              path="/Driver-Task-Receipt/:id"
              element={
                <PrivateRoute permission="/Driver-Task-Receipt/:id">
                  <DriverTaskReceipt />
                </PrivateRoute>
              }
            />

            <Route
              path="/RecevingPaymentSync"
              element={
                <PrivateRoute permission="/RecevingPaymentSync">
                  <RecevingPaymentSync />
                </PrivateRoute>
              }
            />

            <Route
              path="/new-inventory-count"
              element={
                <PrivateRoute permission="/new-inventory-count">
                  <NewInventoryCount />
                </PrivateRoute>
              }
            />
            <Route
              path="/new-inventory-count/:id"
              element={
                <PrivateRoute permission="/new-inventory-count/:id">
                  <NewInventoryCount />
                </PrivateRoute>
              }
            />
            <Route
              path="/show-closed-counts"
              element={
                <PrivateRoute permission="/show-closed-counts">
                  <ShowClosedCounts />
                </PrivateRoute>
              }
            />
            <Route
              path="/item-not-counted-and-in-stock"
              element={
                <PrivateRoute permission="/item-not-counted-and-in-stock">
                  <ItemNotCountedAndInStock />
                </PrivateRoute>
              }
            />
            <Route
              path="/item-not-counted"
              element={
                <PrivateRoute permission="/item-not-counted">
                  <ItemNotCounted />
                </PrivateRoute>
              }
            />
            <Route
              path="/item-excel-import-count/:id"
              element={
                <PrivateRoute permission="/item-excel-import-count/:id">
                  <ExcelImport />
                </PrivateRoute>
              }
            />
            <Route
              path="/import-items"
              element={
                <PrivateRoute permission="/import-items">
                  <ImportItems />
                </PrivateRoute>
              }
            />
            <Route
              path="/item-count-inventory-barcode-label/:id"
              element={
                <PrivateRoute permission="/item-count-inventory-barcode-label/:id">
                  <CountInventoryBarcodeLabel />
                </PrivateRoute>
              }
            />

            {/* Itemskit */}
            <Route
              path="/item-Kits"
              element={
                <PrivateRoute permission="/item-Kits">
                  <Itemskit />
                </PrivateRoute>
              }
            />

            <Route
              path="/quantity-adjustment"
              element={
                <PrivateRoute permission="/quantity-adjustment">
                  <InventoryAdjustment />
                </PrivateRoute>
              }
            />

            {/* manage Itemskit */}
            <Route
              path="/manage-item-Kits"
              element={
                <PrivateRoute permission="/manage-item-Kits">
                  <Manageitemskit />
                </PrivateRoute>
              }
            />
            {/* Deleted Items Kit */}
            <Route
              path="/deleted-items-Kits"
              element={
                <PrivateRoute permission="/deleted-items-kits">
                  <DeletedItemsKit />
                </PrivateRoute>
              }
            />

            {/* Custom Field Config */}
            <Route
              path="/items-kit-custom-fields"
              element={
                <PrivateRoute permission="/items-kit-custom-fields">
                  <ItemKitCustomField />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-item-Kits/:id"
              element={
                <PrivateRoute permission="/manage-item-Kits/:id">
                  <Manageitemskit />
                </PrivateRoute>
              }
            />

            {/* Tags */}
            <Route
              path="/tags"
              element={
                <PrivateRoute permission="/tags">
                  <Tags />
                </PrivateRoute>
              }
            />

            {/* Categories */}
            <Route
              path="/categories"
              element={
                <PrivateRoute permission="/categories">
                  <Categories />
                </PrivateRoute>
              }
            />

            {/* Manufacturers */}
            <Route
              path="/manufacturers"
              element={
                <PrivateRoute permission="/manufacturers">
                  <Manufacturers />
                </PrivateRoute>
              }
            />

            {/* Modifiers */}
            <Route
              path="/modifiers-list"
              element={
                <PrivateRoute permission="/modifiers-list">
                  <Modifiers />
                </PrivateRoute>
              }
            />

            <Route
              path="/modifiers-manage/:id"
              element={
                <PrivateRoute permission="/modifiers-manage/:id">
                  <ModifiersManage />
                </PrivateRoute>
              }
            />

            <Route
              path="/modifiers-manage"
              element={
                <PrivateRoute permission="/modifiers-manage">
                  <ModifiersManage />
                </PrivateRoute>
              }
            />

            {/* Attributes */}
            <Route
              path="/attributes"
              element={
                <PrivateRoute permission="/attributes">
                  <Attributes />
                </PrivateRoute>
              }
            />

            {/* {Role Tier} */}

            <Route
              path="/role-tier"
              element={
                <PrivateRoute permission="/role-tier">
                  <RoleTier />
                </PrivateRoute>
              }
            ></Route>

            {/* Price Rules */}
            <Route
              path="/price-rules"
              element={
                <PrivateRoute permission="/price-rules">
                  <PriceRule />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-price-rules/:id"
              element={
                <PrivateRoute permission="/manage-price-rules/:id">
                  <ManagePriceRule />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-price-rules"
              element={
                <PrivateRoute permission="/manage-price-rules">
                  <ManagePriceRule />
                </PrivateRoute>
              }
            />

            <Route
              path="/recall-price"
              element={
                <PrivateRoute permission="/recall-price">
                  <RecallPrice />
                </PrivateRoute>
              }
            />

            <Route
              path="/promotion-price"
              element={
                <PrivateRoute permission="/promotion-price">
                  <PromotionPrice />
                </PrivateRoute>
              }
            />

            <Route
              path="/deleted-price-rules"
              element={
                <PrivateRoute permission="/deleted-price-rules">
                  <DeletedPriceRules />
                </PrivateRoute>
              }
            />

            <Route
              path="/inventory-stock-status"
              element={
                <PrivateRoute permission="/inventory-stock-status">
                  <InventoryStockStatus />
                </PrivateRoute>
              }
            />

            <Route
              path="/inventory-stock-status-by-category"
              element={
                <PrivateRoute permission="/inventory-stock-status">
                  <InventoryStockStatusByCategory />
                </PrivateRoute>
              }
            />

            {/* Customers */}
            <Route
              path="/customers"
              element={
                <PrivateRoute permission="/customers">
                  <Customers />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-customers"
              element={
                <PrivateRoute permission="/manage-customers">
                  <ManageCustomer />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-customers/:id"
              element={
                <PrivateRoute permission="/manage-customers/:id">
                  <ManageCustomer />
                </PrivateRoute>
              }
            />

            <Route
              path="/customer-intake-form"
              element={
                <PrivateRoute permission="/customer-intake-form">
                  <CustomerIntakeForm />
                </PrivateRoute>
              }
            />

            <Route
              path="/deleted-customers"
              element={
                <PrivateRoute permission="/deleted-customers">
                  <DeletedCustomers />
                </PrivateRoute>
              }
            />

            <Route
              path="/import-excel-customers"
              element={
                <PrivateRoute permission="/import-excel-customers">
                  <ImportExcelCustomers />
                </PrivateRoute>
              }
            />

            {/* item barcode Label */}
            <Route
              path="/item-barcode-label"
              element={
                <PrivateRoute permission="/item-barcode-label">
                  <ItemBarcodeLabel />
                </PrivateRoute>
              }
            />

            {/* customer Barcode label */}
            <Route
              path="/customer-barcode-label"
              element={
                <PrivateRoute permission="/customer-barcode-label">
                  <CustomerBarcodeLabel />
                </PrivateRoute>
              }
            />

            {/* StoreConfig Route */}
            <Route
              path="/storeconfig"
              element={
                <PrivateRoute permission="/storeconfig">
                  <Storeconfig />
                </PrivateRoute>
              }
            />

            {/* custom-field-configuration */}
            <Route
              path="/custom-field-configuration"
              element={
                <PrivateRoute permission="/custom-field-configuration">
                  <CustomFieldConfigurationCustomer />
                </PrivateRoute>
              }
            />

            {/* Supplier List */}
            <Route
              path="/suppliers"
              element={
                <PrivateRoute permission="/suppliers">
                  <Suppliers />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-suppliers"
              element={
                <PrivateRoute permission="/manage-suppliers">
                  <ManageSuppliers />
                </PrivateRoute>
              }
            />

            <Route
              path="/deleted-suppliers"
              element={
                <PrivateRoute permission="/deleted-suppliers">
                  <DeletedSuppliers />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-suppliers/:id"
              element={
                <PrivateRoute permission="/manage-suppliers/:id">
                  <ManageSuppliers />
                </PrivateRoute>
              }
            />

            <Route
              path="/import-excel-suppliers"
              element={
                <PrivateRoute permission="/import-excel-suppliers">
                  <ImportExcelSupplier />
                </PrivateRoute>
              }
            />

            {/* custom-field-configuration */}
            <Route
              path="/custom-field-Suppliers-configuration"
              element={
                <PrivateRoute permission="/custom-field-suppliers-configuration">
                  <CustomFIeldConfigSuppliers />
                </PrivateRoute>
              }
            />

            {/* Receiving */}
            <Route
              path="/receiving"
              element={
                <PrivateRoute permission="/receiving">
                  <Receiving />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-receiving"
              element={
                <PrivateRoute permission="/manage-receiving">
                  <ManageReceiving />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-receiving/:id"
              element={
                <PrivateRoute permission="/manage-receiving/:id">
                  <ManageReceiving />
                </PrivateRoute>
              }
            />

            <Route
              path="/Expense"
              element={
                <PrivateRoute permission="/Expense">
                  <ExpenseNewLayout />
                </PrivateRoute>
              }
            />
            <Route
              path="/ExpenseList"
              element={
                <PrivateRoute permission="/ExpenseList">
                  <ExpenseList />
                </PrivateRoute>
              }
            />
            <Route
              path="/Expense/:id"
              element={
                <PrivateRoute permission="/Expense/:id">
                  <ExpenseNewLayout />
                </PrivateRoute>
              }
            />

            <Route
              path="/receiving-custom-field"
              element={
                <PrivateRoute permission="/receiving-custom-field">
                  <CustomFIeldConfigReceiving />
                </PrivateRoute>
              }
            />
            <Route
              path="/suspended-receiving/:id"
              element={
                <PrivateRoute permission="/suspended-receiving/:id">
                  <SuspendedReceiving />
                </PrivateRoute>
              }
            />
            <Route
              path="/receiving-receipt"
              element={
                <PrivateRoute permission="/receiving-receipt">
                  <ReceivingReceipt />
                </PrivateRoute>
              }
            />
            <Route
              path="/receiving-receipt/:id"
              element={
                <PrivateRoute permission="/receiving-receipt/:id">
                  <ReceivingReceipt />
                </PrivateRoute>
              }
            />

            <Route
              path="/batch-receiving"
              element={
                <PrivateRoute permission="/batch-receiving">
                  <BatchReceiving />
                </PrivateRoute>
              }
            />
            <Route
              path="/transfer-request/:id"
              element={
                <PrivateRoute permission="/transfer-request/:id">
                  {/* <TransferReceiving /> */}
                  <SuspendedReceiving />
                </PrivateRoute>
              }
            />
            <Route
              path="/incoming-transfer/:id"
              element={
                <PrivateRoute permission="/incoming-transfer/:id">
                  <IncomingTransfer />
                </PrivateRoute>
              }
            />
            <Route
              path="/create-purchase-orders"
              element={
                <PrivateRoute permission="/create-purchase-orders">
                  <CreatePurchaseOrders />
                </PrivateRoute>
              }
            />

            <Route
              path="/receiving-barcode-label"
              element={
                <PrivateRoute permiss ion="/receiving-barcode-label">
                  <RecievingBarcodeLabel />
                </PrivateRoute>
              }
            />

            <Route
              path="/receiving-barcode-label/:id"
              element={
                <PrivateRoute permiss ion="/receiving-barcode-label/:id">
                  <RecievingBarcodeLabel />
                </PrivateRoute>
              }
            />
            <Route
              path="/receiving-paybills"
              element={
                <PrivateRoute permission="/receiving-paybills">
                  <PayBillsQuickbook />
                </PrivateRoute>
              }
            />
            <Route
              path="/receiving-expenses"
              element={
                <PrivateRoute permission="/receiving-expenses">
                  <PayBillsExpensesQuickbook />
                </PrivateRoute>
              }
            />
            <Route
              path="/receiving-paybills/:id"
              element={
                <PrivateRoute permission="/receiving-paybills/:id">
                  <PayBillsQuickbook />
                </PrivateRoute>
              }
            />

            <Route
              path="/paybills"
              element={
                <PrivateRoute permission="/receiving-paybills">
                  <PayBills />
                </PrivateRoute>
              }
            />
            <Route
              path="/paybills/:id"
              element={
                <PrivateRoute permission="/receiving-paybills/:id">
                  <PayBills />
                </PrivateRoute>
              }
            />

            <Route
              path="/paymentmethods"
              element={
                <PrivateRoute permission="/paymentmethods">
                  <PaymentMethods />
                </PrivateRoute>
              }
            />

            {/* Sales */}
            <Route
              path="/sales"
              element={
                <PrivateRoute permission="/sales">
                  <Sales />
                </PrivateRoute>
              }
            />

            {/* Ecom Orders */}
            <Route
              path="/ecom-orders"
              element={
                <PrivateRoute permission="/ecom-orders">
                  <EcomOrders />
                </PrivateRoute>
              }
            />

            {/* Sales */}
            <Route
              path="/manage-sales"
              element={
                <PrivateRoute permission="/manage-sales">
                  <ManageSale />
                </PrivateRoute>
              }
            />

            <Route
              path="/receive-payment"
              element={
                <PrivateRoute permission="/receive-payment">
                  <ReceivePaymentQuickbook />
                </PrivateRoute>
              }
            />
            <Route
              path="/receive-payment/:id"
              element={
                <PrivateRoute permission="/receive-payment/:id">
                  <ReceivePaymentQuickbook />
                </PrivateRoute>
              }
            />

            <Route
              path="/recvpayment"
              element={
                <PrivateRoute permission="/receive-payment">
                  <ReceivePayment />
                </PrivateRoute>
              }
            />
            <Route
              path="/recvpayment/:id"
              element={
                <PrivateRoute permission="/receive-payment/:id">
                  <ReceivePayment />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-adjustment/:id"
              element={
                <PrivateRoute permission="/manage-adjustment/:id">
                  <ManageFormAdjustment />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-sales/:id"
              element={
                <PrivateRoute permission="/manage-sales/:id">
                  <ManageSale />
                </PrivateRoute>
              }
            />

            <Route
              path="/custom-field-sales-configuration"
              element={
                <PrivateRoute permission="/custom-field-sales-configuration">
                  <CustomFIeldConfigSales />
                </PrivateRoute>
              }
            />

            <Route
              path="/suspended-sales"
              element={
                <PrivateRoute permission="/suspended-sales">
                  <SuspendedSales />
                </PrivateRoute>
              }
            />
            <Route
              path="/suspended-sales/:id"
              element={
                <PrivateRoute permission="/suspended-sales/:id">
                  <SuspendedSales />
                </PrivateRoute>
              }
            />

            <Route
              path="/sales-workorders"
              element={
                <PrivateRoute permission="/sales-workorders">
                  <SalesWorkOrders />
                </PrivateRoute>
              }
            />
            <Route
              path="/sales-customer-facing-display"
              element={
                <PrivateRoute permission="/sales-customer-facing-display">
                  <CustomerFacingDisplay />
                </PrivateRoute>
              }
            />

            <Route
              path="/batch-sales"
              element={
                <PrivateRoute permission="/batch-sales">
                  <BatchSale />
                </PrivateRoute>
              }
            />

            <Route
              path="/search-sales"
              element={
                <PrivateRoute permission="/search-sales">
                  <SearchSale />
                </PrivateRoute>
              }
            />
            <Route
              path="/sales-receipt"
              element={
                <PrivateRoute permission="/sales-receipt">
                  <ShowLastSaleReceipt />
                </PrivateRoute>
              }
            />
            <Route
              path="/sales-receipt/:id"
              element={
                <PrivateRoute permission="/sales-receipt/:id">
                  <ShowLastSaleReceipt />
                </PrivateRoute>
              }
            />
            <Route
              path="/print-sales-receipts"
              element={
                <PrivateRoute permission="/sales-receipt">
                  <PrintSaleReceipts />
                </PrivateRoute>
              }
            />
            <Route
              path="/sales-barcode-label"
              element={
                <PrivateRoute permission="/sales-barcode-label">
                  <SaleBarcodeLabel />
                </PrivateRoute>
              }
            />
            <Route
              path="/sales-barcode-label/:id"
              element={
                <PrivateRoute permission="/sales-barcode-label/:id">
                  <SaleBarcodeLabel />
                </PrivateRoute>
              }
            />

            <Route
              path="/sales-all-receipt"
              element={
                <PrivateRoute permission="/sales-all-receipt">
                  <ShowAllReceiptToday />
                </PrivateRoute>
              }
            />

            {/* Deliveries */}
            {/* <Route
              path="/deliveries"
              element={
                <PrivateRoute permission="/deliveries">
                  <Deliveries />
                </PrivateRoute>
              }
            /> */}
            {/*  Deleted Deliveries */}
            {/* <Route
              path="/deleted-deliveries"
              element={
                <PrivateRoute permission="/deleted-deliveries">
                  <DeletedDeliveries />
                </PrivateRoute>
              }
            /> */}
            {/*  manage Deliveries */}
            {/* <Route
              path="/manage-deliveries"
              element={
                <PrivateRoute permission="/manage-deliveries">
                  <ManageDeliveries />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-deliveries/:id"
              element={
                <PrivateRoute permission="/manage-deliveries/:id">
                  <ManageDeliveries />
                </PrivateRoute>
              }
            /> */}
            {/* <Route
              path="/manage-status"
              element={
                <PrivateRoute permission="/manage-status">
                  <ManageStatus />
                </PrivateRoute>
              }
            /> */}
            {/* <Route
              path="/manage-deliveries-categories"
              element={
                <PrivateRoute permission="/manage-deliveries-categories">
                  <ManageCategory />
                </PrivateRoute>
              }
            /> */}
            {/* <Route
              path="/manage-deliveries-emailtemplates"
              element={
                <PrivateRoute permission="/manage-deliveries-emailtemplates">
                  <ManageEmailTemplate />
                </PrivateRoute>
              }
            /> */}

            {/* Employees listing */}
            <Route
              path="/employees"
              element={
                <PrivateRoute permission="/employees">
                  <Employees />
                </PrivateRoute>
              }
            />

            {/*  Deleted Employees */}
            <Route
              path="/deleted-employees"
              element={
                <PrivateRoute permission="/deleted-employees">
                  <DeletedEmployees />
                </PrivateRoute>
              }
            />
            <Route
              path="/inactive-employees"
              element={
                <PrivateRoute permission="/deleted-employees">
                  <InActiveEmployees />
                </PrivateRoute>
              }
            />

            {/* Employees Upsert */}
            <Route
              path="/manage-employee"
              element={
                <PrivateRoute permission="/manage-employee">
                  <ManageEmployee />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-employee/:id"
              element={
                <PrivateRoute permission="/manage-employee/:id">
                  <ManageEmployee />
                </PrivateRoute>
              }
            />

            {/* custom-field-configuration-employee */}
            <Route
              path="/custom-field-employee-configuration"
              element={
                <PrivateRoute permission="/custom-field-employee-configuration">
                  <CustomFieldConfigEmployee />
                </PrivateRoute>
              }
            />

            {/* Work-orders */}
            {/* <Route
              path="/workorders"
              element={
                <PrivateRoute permission="/workorders">
                  <WorkOrders />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-workorder-status"
              element={
                <PrivateRoute permission="/manage-workorder-status">
                  <ManageWorkorderStatues />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-workorder-emailtemplates"
              element={
                <PrivateRoute permission="/manage-workorder-emailtemplates">
                  <ManageTemplates />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-workorder-delete"
              element={
                <PrivateRoute permission="/manage-workorder-delete">
                  <ManageWorkorderDeleted />
                </PrivateRoute>
              }
            />
            <Route
              path="/editworkorder/:id"
              element={
                <PrivateRoute permission="/editworkorder/:id">
                  <EditWorkOrder />
                </PrivateRoute>
              }
            />
            <Route
              path="/workorder-barcode-label"
              element={
                <PrivateRoute permission="/workorder-barcode-label">
                  <WorkOrderBarcodeLabel />
                </PrivateRoute>
              }
            /> */}

            {/* Permission Template */}
            <Route
              path="/manage-permissions"
              element={
                <PrivateRoute permission="/manage-permissions">
                  <Permission />
                </PrivateRoute>
              }
            />
            <Route
              path="/new-permission-template"
              element={
                <PrivateRoute permission="/new-permission-template">
                  <NewPermissionTemplate />
                </PrivateRoute>
              }
            />

            {/* Appointment */}
            {/* <Route
              path="/appointments"
              element={
                <PrivateRoute permission="/appointments">
                  <Appointment />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-appointment/:id"
              element={
                <PrivateRoute permission="/manage-appointment/:id">
                  <AppointmentIntakeForm />
                </PrivateRoute>
              }
            />
            <Route
              path="/new-appointment"
              element={
                <PrivateRoute permission="/new-appointment">
                  <AppointmentIntakeForm />
                </PrivateRoute>
              }
            /> */}

            {/* Deleted Appointment List */}
            {/* <Route
              path="/deleted-appointments"
              element={
                <PrivateRoute permission="/deleted-appointments">
                  <DeletedAppointment />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-categories"
              element={
                <PrivateRoute permission="/manage-categories">
                  <ManageCategories />
                </PrivateRoute>
              }
            /> */}

            {/* locations */}

            <Route
              path="/locations"
              element={
                <PrivateRoute permission="/locations">
                  <Locations />
                </PrivateRoute>
              }
            />

            {/* <Route
              path="/manage-locations"
              element={
                <PrivateRoute permission="/manage-locations">
                  <ManageLocations />
                </PrivateRoute>
              }
            /> */}
            <Route
              path="/manage-locations"
              element={
                <PrivateRoute permission="/manage-locations">
                  <ManageLocationsNew />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-locations/:id"
              element={
                <PrivateRoute permission="/manage-locations/:id">
                  <ManageLocationsNew />
                </PrivateRoute>
              }
            />

            <Route
              path="/deleted-locations"
              element={
                <PrivateRoute permission="/deleted-locations">
                  <DeletedLocations />
                </PrivateRoute>
              }
            />

            {/* Brands  */}
            <Route
              path="/brand"
              element={
                <PrivateRoute permission="/brand">
                  <Brand />
                </PrivateRoute>
              }
            />

            {/* Accounting */}
            <Route
              path="/accounting"
              element={
                <PrivateRoute permission="/accounting">
                  <ChartOfAccount />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-inactive-account"
              element={
                <PrivateRoute permission="/manage-inactive-account">
                  <ManageInactiveAccount />
                </PrivateRoute>
              }
            />

            <Route
              path="/manage-adjustment"
              element={
                <PrivateRoute permission="/manage-adjustment">
                  <ManageFormAdjustment />
                </PrivateRoute>
              }
            />

            {/* Accounting Edit Page*/}
            <Route
              path="/manage-account/:id"
              element={
                <PrivateRoute permission="/manage-account/:id">
                  <ChartOfAccountManage />
                </PrivateRoute>
              }
            />

            <Route
              path="/account-report/:id"
              element={
                <PrivateRoute permission="/account-report/:id">
                  <AccountsRunReport />
                </PrivateRoute>
              }
            />
            <Route
              path="/account-report"
              element={
                <PrivateRoute permission="/account-report">
                  <AccountsRunReport />
                </PrivateRoute>
              }
            />
            {/* <Route
              path="/account-report/:id"
              element={
                <PrivateRoute permission="/account-report/:id">
                  <ChartOfAccountReport />
                </PrivateRoute>
              }
            />
            <Route
              path="/account-report"
              element={
                <PrivateRoute permission="/account-report">
                  <ChartOfAccountReport />
                </PrivateRoute>
              }
            /> */}

            {/* Accounting Add Page*/}
            <Route
              path="/manage-account"
              element={
                <PrivateRoute permission="/manage-account">
                  <ChartOfAccountManage />
                </PrivateRoute>
              }
            />

            {/* AccountType List Page*/}
            <Route
              path="/chartofaccounttype-list"
              element={
                <PrivateRoute permission="/chartofaccounttype-list">
                  <CharOfAccountTypes />
                </PrivateRoute>
              }
            />

            {/* Bank Deposit */}
            <Route
              path="/bank-deposit"
              element={
                <PrivateRoute permission="/bank-deposit">
                  <BankDeposits />
                </PrivateRoute>
              }
            />

            <Route
              path="/bank-deposit/:id"
              element={
                <PrivateRoute permission="/bank-deposit/:id">
                  <BankDeposits />
                </PrivateRoute>
              }
            />

            {/* Transfer */}
            <Route
              path="/transfer"
              element={
                <PrivateRoute permission="/transfer">
                  <Transfer />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-transfer/:id"
              element={
                <PrivateRoute permission="/manage-transfer/:id">
                  <ManageTransfer />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-transfer"
              element={
                <PrivateRoute permission="/manage-transfer">
                  <ManageTransfer />
                </PrivateRoute>
              }
            />

            {/* View Register */}
            <Route
              path="/view-register/:id"
              element={
                <PrivateRoute permission="/view-register/:id">
                  <ViewRegister />
                </PrivateRoute>
              }
            />

            {/* View Register V2*/}
            <Route
              path="/vregister/:id"
              element={
                <PrivateRoute permission="/view-register/:id">
                  <ViewRegisterQuickbookSc />
                </PrivateRoute>
              }
            />
            <Route
              path="/vregisters/:id"
              element={
                <PrivateRoute permission="/view-register/:id">
                  <ViewRegisterQuickbook />
                </PrivateRoute>
              }
            />

            {/* Journal Entry */}
            <Route
              path="/journal-entry"
              element={
                <PrivateRoute permission="/journal-entry">
                  <JournalEntry />
                </PrivateRoute>
              }
            />

            <Route
              path="/journal-entry/:id"
              element={
                <PrivateRoute permission="/journal-entry/:id">
                  <JournalEntry />
                </PrivateRoute>
              }
            />

            {/* Journal Listing */}
            <Route
              path="/journals"
              element={
                <PrivateRoute permission="/journals">
                  <Journal />
                </PrivateRoute>
              }
            />

            {/* Task */}
            <Route
              path="/task"
              element={
                <PrivateRoute permission="/task">
                  <Task />
                </PrivateRoute>
              }
            />

            {/* Payment Log */}
            <Route
              path="/transaction-log"
              element={
                <PrivateRoute permission="/transaction-log">
                  <PaymentLog />
                </PrivateRoute>
              }
            />

            {/* Manage Task */}

            <Route
              path="/manage-task"
              element={
                <PrivateRoute permission="/manage-task">
                  <ManageTask />
                </PrivateRoute>
              }
            />

            {/* AccountType Add Page
            {/* <Route
            path="/manage-accounttype"
            element={
              // <PrivateRoute permission="/accounting">
              <AccountTypesManage />
              // </PrivateRoute>
            }
          /> */}

            {/* AccountType Edit Page*/}
            {/* <Route
            path="/manage-accounttype/:id"
            element={
              // <PrivateRoute permission="/accounting">
              <AccountTypesManage />
              // </PrivateRoute>
            }
          /> */}

            {/* AccountType Edit Page*/}
            {/* <Route
            path="/manage-accounttypedetlis/:id"
            element={
              // <PrivateRoute permission="/accounting">
              <AccountTypesDetailsManage />
              // </PrivateRoute>
            }
          /> */}

            {/* Location Rack Manegment */}
            <Route
              path="/manage-locationrack"
              element={
                <PrivateRoute permission="/manage-locationrack">
                  <LoactionRackMangement />
                </PrivateRoute>
              }
            />

            <Route
              path="/sub-company/:id"
              element={
                <PrivateRoute permission="/sub-company/:id">
                  <SubCompany />
                </PrivateRoute>
              }
            />
            <Route
              path="/sub-company"
              element={
                <PrivateRoute permission="/sub-company">
                  <SubCompany />
                </PrivateRoute>
              }
            />

            <Route
              path="/sub-company-list"
              element={
                <PrivateRoute permission="/sub-company-list">
                  <ManageSubCompany />
                </PrivateRoute>
              }
            />

            {/* AccountType List Page*/}
            <Route
              path="/accounttype-list"
              element={
                <PrivateRoute permission="/accounttype-list">
                  <AccountTypes />
                </PrivateRoute>
              }
            />

            {/* AccountsTypes Details List Page */}
            <Route
              path="/accounttypedetlis-list"
              element={
                <PrivateRoute permission="/accounttypedetlis-list">
                  <AccountTypesDetails />
                </PrivateRoute>
              }
            />

            {/* Gift Card */}
            <Route
              path="/giftcard"
              element={
                <PrivateRoute permission="/giftcard">
                  <GiftCard />
                </PrivateRoute>
              }
            />
            <Route
              path="manage-giftcard"
              element={
                <PrivateRoute permission="/manage-giftcard">
                  <ManageGiftCard />
                </PrivateRoute>
              }
            />
            <Route
              path="/manage-giftcard/:id"
              element={
                <PrivateRoute permission="/manage-giftcard/:id">
                  <ManageGiftCard />
                </PrivateRoute>
              }
            />
            <Route
              path="/deleted-giftcard"
              element={
                <PrivateRoute permission="/deleted-giftcard">
                  <DeletedGiftCard />
                </PrivateRoute>
              }
            />

            {/* Email Templates */}
            <Route
              path="/email-templates"
              element={
                <PrivateRoute permission="/email-templates">
                  <EmailTemplates />
                </PrivateRoute>
              }
            />
            <Route
              path="/new-email-templates"
              element={
                <PrivateRoute permission="/new-email-templates">
                  <ManageEmailTemplates />
                </PrivateRoute>
              }
            />
            <Route
              path="/new-email-templates/:id"
              element={
                <PrivateRoute permission="/new-email-templates/:id">
                  <ManageEmailTemplates />
                </PrivateRoute>
              }
            />
            {/* Ecomm Config */}
            <Route
              path="/ecommconfig"
              element={
                <PrivateRoute permission="/ecommconfig">
                  <EcommConfig />
                </PrivateRoute>
              }
            />

            {/* Ecomm Users */}
            <Route
              path="/ecommusers"
              element={
                <PrivateRoute permission="/ecommusers">
                  <EcommUsers />
                </PrivateRoute>
              }
            />

            {/* Quickbooks Sync */}

            <Route
              path="/quickbooksync"
              element={
                <PrivateRoute permission="/quickbooksync">
                  <QuickbookSync />
                </PrivateRoute>
              }
            ></Route>

            {/* Reports */}

            {/* Reports */}
            <Route
              path="/reports"
              element={
                <PrivateRoute permission="/reports">
                  <ReportsList />
                </PrivateRoute>
              }
            />

            <Route
              path="/undepositedsummaryreport"
              element={
                <PrivateRoute permission="/undepositedsummaryreport">
                  <Undepositedbalancesummery />
                </PrivateRoute>
              }
            />

            <Route
              path="/inventoryValuationReport"
              element={
                <PrivateRoute permission="/undepositedsummaryreport">
                  <InventoryValuationReport />
                </PrivateRoute>
              }
            />

            <Route
              path="/customer-balance-summary"
              element={
                <PrivateRoute permission="/customer-balance-summary">
                  <CustomerBalanceSummary />
                </PrivateRoute>
              }
            />
            <Route
              path="/expense-report"
              element={
                <PrivateRoute permission="/expense-report">
                  <ExpenseReport />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/customer-contact-list"
              element={
                <PrivateRoute permission="/customer-contact-list">
                  <CustomerContactList />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/sales-by-customer-detail"
              element={
                <PrivateRoute permission="/sales-by-customer-detail">
                  <SalesbyCustomerDetail />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/sales-by-categories"
              element={
                <PrivateRoute permission="/sales-by-categories">
                  <SalesByCategoriesNew />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/sales-by-categories-summary"
              element={
                <PrivateRoute permission="/sales-by-categories-summary">
                  <SalesByCategoriesNewSummary />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/sales-by-brand-summary"
              element={
                <PrivateRoute permission="/sales-by-brand-summary">
                  <SalesByBrandsNewSummary />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/purchase-by-brand-summary"
              element={
                <PrivateRoute permission="/purchase-by-brand-summary">
                  <PurchasesByBrandsNewSummary />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/purchase-by-categories-summary"
              element={
                <PrivateRoute permission="/purchase-by-categories-summary">
                  <PurchasesByCategoriesSummary />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/sales-by-categories-advance"
              element={
                <PrivateRoute permission="/sales-by-categories-advance">
                  <SalesByCategories />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/sales-by-customer-type-detail"
              element={
                <PrivateRoute permission="/sales-by-customer-type-detail">
                  <SalesbyCustomerTypeDetail />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/transaction-list-by-customer"
              element={
                <PrivateRoute permission="/transaction-list-by-customer">
                  <TransactionListByCustomer />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/sales-by-customer-summary-report"
              element={
                <PrivateRoute permission="/sales-by-customer-summary-report">
                  <SalesbyCustomerSummaryReport />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/vendor-balance-summary"
              element={
                <PrivateRoute permission="/vendor-balance-summary">
                  <VendorBalanceSummary />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/expenses-by-vendor-summary"
              element={
                <PrivateRoute permission="/expenses-by-vendor-summary">
                  <ExpensesbyVendorSummary />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/open-purchase-order-list"
              element={
                <PrivateRoute permission="/open-purchase-order-list">
                  <OpenPurchaseOrderList />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/deleted-sales-report"
              element={
                <PrivateRoute permission="/deleted-sales-report">
                  <DeletedSales />
                </PrivateRoute>
              }
            />
            <Route
              path="/sales-by-brands"
              element={
                <PrivateRoute permission="/sales-by-brands">
                  <SalesByBrandsReport />
                </PrivateRoute>
              }
            />
            <Route
              path="/sales-velocity-report"
              element={
                <PrivateRoute permission="/sales-velocity-report">
                  <SalesVelocityReport />
                </PrivateRoute>
              }
            />

            <Route
              path="/demo-report"
              element={
                <PrivateRoute permission="/sales-velocity-report">
                  <Demoreport />
                </PrivateRoute>
              }
            />
            <Route
              path="/sales-by-brands-aging"
              element={
                <PrivateRoute permission="/sales-by-brands-aging">
                  <SalesByBrandAgingReport />
                </PrivateRoute>
              }
            />
            <Route
              path="/profit-by-delivery-methods-summary"
              element={
                <PrivateRoute permission="/profit-by-delivery-methods-summary">
                  <ProfitByDeliveryMethodsSummary />
                </PrivateRoute>
              }
            />
            <Route
              path="/profit-by-delivery-methods-detail"
              element={
                <PrivateRoute permission="/profit-by-delivery-methods-detail">
                  <ProfitByDeliveryMethodsDetail />
                </PrivateRoute>
              }
            />
            <Route
              path="/deposit-detail-report"
              element={
                <PrivateRoute permission="/deposit-detail-report">
                  <DepositDetailReport />
                </PrivateRoute>
              }
            />
            <Route
              path="/sales-by-category-aging"
              element={
                <PrivateRoute permission="/sales-by-category-aging">
                  <SalesByCategoriesAgingReport />
                </PrivateRoute>
              }
            />
            <Route
              path="/purchase-by-brands"
              element={
                <PrivateRoute permission="/purchase-by-brands">
                  <PurchaseByBrands />
                </PrivateRoute>
              }
            />
            <Route
              path="/purchase-by-category"
              element={
                <PrivateRoute permission="/purchase-by-category">
                  <PurchaseByCategories />
                </PrivateRoute>
              }
            />

            <Route
              path="/transaction-list-by-vendor"
              element={
                <PrivateRoute permission="/transaction-list-by-vendor">
                  <TransactionListbyVendor />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/transaction-list-by-date"
              element={
                <PrivateRoute permission="/transaction-list-by-vendor">
                  <TransactionListbyDate />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/invoices-and-received-payments"
              element={
                <PrivateRoute permission="/invoices-and-received-payments">
                  <InvoicesandReceivedPayments />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/customer-balance-detail"
              element={
                <PrivateRoute permission="/customer-balance-detail">
                  <CustomerBalanceDetail />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/open-invoices"
              element={
                <PrivateRoute permission="/open-invoices">
                  <OpenInvoices />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/sales-by-product-service-detail"
              element={
                <PrivateRoute permission="/sales-by-product-service-detail">
                  <SalesbyProductServiceDetail />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/vendor-balance-detail"
              element={
                <PrivateRoute permission="/vendor-balance-detail">
                  <VendorBalanceDetail />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/open-purchase-order-detail"
              element={
                <PrivateRoute permission="/open-purchase-order-detail">
                  <OpenPurchaseOrderDetail />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/vendor-contact-list"
              element={
                <PrivateRoute permission="/vendor-contact-list">
                  <VendorContactList />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/employee-contact-list"
              element={
                <PrivateRoute permission="/employee-contact-list">
                  <EmployeeContactList />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/profit-loss-customer"
              element={
                <PrivateRoute permission="/profit-loss-customer">
                  <ProfitandLossbyCustomer />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/trial-balance"
              element={
                <PrivateRoute permission="/trial-balance">
                  <TrialBalance />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/profit-and-loss-detail"
              element={
                <PrivateRoute permission="/profit-and-loss-detail">
                  <ProfitandLossDetail />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/balance-sheet-detail"
              element={
                <PrivateRoute permission="/balance-sheet-detail">
                  <BalanceSheetDetail />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/registers-by-payment-methods"
              element={
                <PrivateRoute permission="/registers-by-payment-methods">
                  <RegistersReportByPayementMethods />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/income-by-customer-summery"
              element={
                <PrivateRoute permission="/income-by-customer-summery">
                  <IncomebyCustomerSummary />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/sales-by-product-service-summery"
              element={
                <PrivateRoute permission="/sales-by-product-service-summery">
                  <SalesbyProductServiceSummary />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/product-service-list"
              element={
                <PrivateRoute permission="/product-service-list">
                  <ProductServiceList />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/bills-applied-payments"
              element={
                <PrivateRoute permission="/bills-applied-payments">
                  <BillsandAppliedPayments />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/unpaid-bills"
              element={
                <PrivateRoute permission="/unpaid-bills">
                  <UnpaidBills />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/balance-sheet-summary"
              element={
                <PrivateRoute permission="/balance-sheet-summary">
                  <BalanceSheetSummary />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/accounts-payable-aging-detail"
              element={
                <PrivateRoute permission="/accounts-payable-aging-detail">
                  <AccountsPayableAgingDetail />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/bill-payment-list"
              element={
                <PrivateRoute permission="/bill-payment-list">
                  <BillPaymentList />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/accounts-receivable-aging-detail"
              element={
                <PrivateRoute permission="/accounts-receivable-aging-detail">
                  <AccountsReceivableAgingDetail />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/accounts-receivable-aging-summary"
              element={
                <PrivateRoute permission="/accounts-receivable-aging-summary">
                  <AccountsReceivableAgingsummary />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/accounts-payable-aging-summary"
              element={
                <PrivateRoute permission="/accounts-payable-aging-summary">
                  <AccountsPayableAgingsummary />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/item-profit-ability-by-customer"
              element={
                <PrivateRoute permission="/item-profit-ability-by-customer">
                  <ItemProfitAbilityByCustomer />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/Sale-Delivery-List"
              element={
                <PrivateRoute permission="/Sale-Delivery-List">
                  <SalesDeliveryReport />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/detailed-sale-by-employee"
              element={
                <PrivateRoute permission="/Sale-By-Employee">
                  <SaleByEmployee />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/sale-by-employee-summary"
              element={
                <PrivateRoute permission="/sale-by-employee-summary">
                  <SaleByEmployeeSummary />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/manufacturer-summary-report"
              element={
                <PrivateRoute permission="/manufacturer-summary-report">
                  <RepotsManufacturer />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/inventory-detailed-report"
              element={
                <PrivateRoute permission="/inventory-detailed-report">
                  <InventoryDetailedReport />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/inventory-summary-report"
              element={
                <PrivateRoute permission="/inventory-summary-report">
                  <InventorySummaryReport />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/price-rules-summary-report"
              element={
                <PrivateRoute permission="/Price-Rule-Summary-Report">
                  <Pricerulesummary />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/Receiving-List-Report"
              element={
                <PrivateRoute permission="/Receiving-List-Report">
                  <ReceivingReport />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/payment-detail-report"
              element={
                <PrivateRoute permission="/payment-detail-report">
                  <PaymentDetailReport />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/items-summary-report"
              element={
                <PrivateRoute permission="/items-summary-report">
                  <ItemSummaryReport />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/custom_search_report"
              element={
                <PrivateRoute permission="/custom_search_report">
                  <CustomSerachReport />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/receiving_custom_report"
              element={
                <PrivateRoute permission="/receiving_custom_report">
                  <ReceivingCustomReport />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/ItemQtyVerify"
              element={
                <PrivateRoute permission="/ItemQtyVerify">
                  <ItemQantity />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/ItemDetilQtyReport"
              element={
                <PrivateRoute permission="/ItemQtyVerify">
                  <ItemDetilReportQty />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/detailed-paybills-report"
              element={
                <PrivateRoute permission="/repots-paybill">
                  <PayBillReport />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/payment-summary-report"
              element={
                <PrivateRoute permission="/payment-summary-report">
                  <PaymentSummaryReport />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/customer-summary-report"
              element={
                <PrivateRoute permission="/customer-summary-report">
                  <CustomerSummaryReport />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/detailed-customers-report"
              element={
                <PrivateRoute permission="/detailed-customers-report">
                  <SaleByCustomerDetailReport />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/supplier-summary-report"
              element={
                <PrivateRoute permission="/supplier-summary-report">
                  <SupplierSummaryReport />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/detailed_register_log"
              element={
                <PrivateRoute permission="/pos">
                  <DetailedRegisterLogsReport />
                </PrivateRoute>
              }
            ></Route>
            <Route
              path="/register_summary_report"
              element={
                <PrivateRoute permission="/pos">
                  <RegisterSummaryReport />
                </PrivateRoute>
              }
            ></Route>

            {/* My Profile */}
            <Route
              path="/edit-profile"
              element={
                <PrivateRoute permission="/edit-profile">
                  <EditProfile />
                </PrivateRoute>
              }
            />

            {/* POS Portal */}
            <Route
              path="/pos"
              element={
                <PrivateRoute permission="/pos">
                  <PosPage />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/posregister"
              element={
                <PrivateRoute permission="/pos">
                  <PosRegisterPage />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/posregister/:id"
              element={
                <PrivateRoute permission="/pos">
                  <PosRegisterPage />
                </PrivateRoute>
              }
            />

            <Route
              path="/register_log_details/:id"
              element={
                <PrivateRoute permission="/pos">
                  <PosRegisterDetailPage />
                </PrivateRoute>
              }
            />

            <Route
              path="/register_add_subtract"
              element={
                <PrivateRoute permission="/pos">
                  <RegisterAddRemoveAmount />
                </PrivateRoute>
              }
            />

            <Route
              path="/master-register"
              element={
                <PrivateRoute permission="/master-register">
                  <MasterRegister />
                </PrivateRoute>
              }
            />

            <Route
              path="/testpos"
              element={
                <PrivateRoute permission="/pos">
                  <ScannerTest />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/pos/:saleId"
              element={
                <PrivateRoute permission="/pos">
                  <PosPage />
                </PrivateRoute>
              }
            ></Route>

            {/* Receving POS Portal */}
            <Route
              path="/pos-receiving"
              element={
                <PrivateRoute permission="/pos-receiving">
                  <RecvPosPage />
                </PrivateRoute>
              }
            ></Route>

            <Route
              path="/pos-receiving/:recivingId"
              element={
                <PrivateRoute permission="/pos-receiving">
                  <RecvPosPage />
                </PrivateRoute>
              }
            ></Route>

            {/* Scanner Page */}
            <Route
              path="/scanner"
              element={
                <PrivateRoute permission="/pos">
                  <Scanner />
                </PrivateRoute>
              }
            ></Route>

            {/* GeorapBox */}
            {/* <Route
              path="/georapbox"
              element={
                <PrivateRoute permission="/pos">
                  <GeorapBox />
                </PrivateRoute>
              }
            ></Route> */}
          </Route>
        </Route>

        {/* Register */}
        <Route path="/register" element={<PublicRoutes />}>
          <Route path="/register" element={<Register />} />
        </Route>

        {/* Ecom Pending Invoice */}
        <Route
          path="/ecompendingincoice"
          element={<ShowLastSaleReceipt ecomreceipt={true} />}
        />
        {/* /:id */}

        {/* Ecom invoice */}
        <Route
          path="/ecominvoice"
          element={<ShowLastSaleReceipt ecomreceipt={true} />}
        />
        {/* /:id */}
        {/* Ecom custom Invoice */}
        <Route
          path="/ecomcustominvoice"
          element={<ShowLastSaleReceipt ecomreceipt={true} />}
        />
        {/* :id/:type */}

        <Route
          path="/customerstatement"
          element={<ManageCustomer ecomreceipt={true} />}
        />

        {/* Login */}
        <Route path="/login" element={<PublicRoutes />}>
          <Route path="/login" element={<Login />} />
        </Route>

        {/* Forgot Password */}
        <Route path="/forgetPassword" element={<PublicRoutes />}>
          <Route path="/forgetPassword" element={<ForgotPassword />} />
        </Route>

        {/* Reset Password */}
        <Route path="/resetpassword/:id" element={<PublicRoutes />}>
          <Route path="/resetpassword/:id" element={<ResetPassword />} />
        </Route>

        {/* Scan to Cart */}
        <Route path="/scantocart/:custId/:roleId" element={<ScanToCart />} />

        {/* error 404 */}
        <Route path="*" element={<Error404 />} />

        {/* error 403 */}
        <Route path="/error403" element={<Error403 />} />

        {/* error 500 */}
        <Route path="/error500" element={<Error500 />} />
      </Routes>
      <ToastContainer />
    </>
  );
};

export default MainRoute;
